<main class="bg-surface-100 min-h-screen flex flex-col lg:p-8">
    <router-outlet></router-outlet>
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>
</main>
